<div
  class="font-display text-text-primary antialiased h-screen w-full overflow-hidden bg-background-light"
>
  @if (!hideAppShell()) {
    <div class="flex h-full w-full overflow-hidden">

      <!-- Mobile/Tablet backdrop -->
      @if (sidebarOpen()) {
        <div
          class="fixed inset-0 bg-black/40 z-30 lg:hidden"
          (click)="closeSidebar()"
        ></div>
      }

      <!-- Sidebar: fixed overlay on mobile/tablet, static on desktop -->
      <aside
        class="fixed inset-y-0 left-0 z-40 flex w-66 flex-col border-r border-border-medium bg-white transition-transform duration-300 ease-in-out lg:static lg:z-auto lg:translate-x-0 lg:transition-none"
        [class.-translate-x-full]="!sidebarOpen()"
      >
        <div class="flex h-16 items-center px-6 border-b border-border-light">
          <!-- The logo is the way home, as it is on most of the web. -->
          <a
            routerLink="/home"
            aria-label="Taolo — go to Home"
            class="-mx-2 flex gap-3 items-center rounded-lg px-2 py-1 transition-colors hover:bg-inset"
          >
            <div
              class="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary"
            >
              <app-logo [size]="24" />
            </div>
            <div>
              <h1
                class="text-text-primary text-base font-extrabold tracking-[-0.03em] leading-tight"
              >
                Taolo
              </h1>
              <p class="text-text-tertiary text-xs font-normal">
                {{ roleLabel() }}
              </p>
            </div>
          </a>
        </div>

        <div class="flex-1 overflow-y-auto py-4 px-3 space-y-1">
          <a
            routerLink="/home"
            routerLinkActive="bg-primary/10 text-primary"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-text-secondary hover:bg-inset hover:text-text-primary transition-colors group"
          >
            <span
              class="material-symbols-outlined group-[.bg-primary\/10]:text-primary group-hover:text-primary transition-colors"
              >home</span
            >
            <span class="text-sm font-medium">Home</span>
          </a>
          <a
            routerLink="/checklists"
            routerLinkActive="bg-primary/10 text-primary"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-text-secondary hover:bg-inset hover:text-text-primary transition-colors group"
          >
            <span
              class="material-symbols-outlined group-[.bg-primary\/10]:text-primary group-hover:text-primary transition-colors"
              >fact_check</span
            >
            <span class="text-sm font-medium">Checklists</span>
          </a>
          @if (canViewTaskHistory()) {
            <a
              routerLink="/task-history"
              routerLinkActive="bg-primary/10 text-primary"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-text-secondary hover:bg-inset hover:text-text-primary transition-colors group"
            >
              <span
                class="material-symbols-outlined group-[.bg-primary\/10]:text-primary group-hover:text-primary transition-colors"
                >history</span
              >
              <span class="text-sm font-medium">Task History</span>
            </a>
          }
          @if (canViewReports()) {
            <a
              routerLink="/reports"
              routerLinkActive="bg-primary/10 text-primary"
              class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-text-secondary hover:bg-inset hover:text-text-primary transition-colors group"
            >
              <span
                class="material-symbols-outlined group-[.bg-primary\/10]:text-primary group-hover:text-primary transition-colors"
                >monitoring</span
              >
              <span class="text-sm font-medium">Compliance</span>
            </a>
          }
          <a
            routerLink="/documents"
            routerLinkActive="bg-primary/10 text-primary"
            class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-text-secondary hover:bg-inset hover:text-text-primary transition-colors group"
          >
            <span
              class="material-symbols-outlined group-[.bg-primary\/10]:text-primary group-hover:text-primary transition-colors"
              >folder</span
            >
            <span class="text-sm font-medium">Documents</span>
          </a>

          <!--
            Below the rule, with Dev Database: everything above it is the daily
            work, everything below it is administration.
          -->
          @if (canViewSetup()) {
            <div class="mt-2 pt-2 border-t border-border-light">
              <a
                routerLink="/setup"
                routerLinkActive="bg-primary/10 text-primary"
                class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-text-secondary hover:bg-inset hover:text-text-primary transition-colors group"
              >
                <span
                  class="material-symbols-outlined group-[.bg-primary\/10]:text-primary group-hover:text-primary transition-colors"
                  >tune</span
                >
                <span class="text-sm font-medium">Setup</span>
              </a>
            </div>
          }

          <!--
            mt-1 rather than the Setup block's border-t: the two gates are
            independent, so both can render and a second rule would draw double.
          -->
          @if (canViewDevDatabase()) {
            <div class="mt-1">
              <a
                routerLink="/admin/database"
                routerLinkActive="bg-primary/10 text-primary"
                class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-text-secondary hover:bg-inset hover:text-text-primary transition-colors group"
              >
                <span
                  class="material-symbols-outlined group-[.bg-primary\/10]:text-primary group-hover:text-primary transition-colors"
                  >database</span
                >
                <span class="text-sm font-medium">Dev Database</span>
              </a>
            </div>
          }
        </div>

        <div class="p-4 border-t border-border-light space-y-3">
          @if (user(); as currentUser) {
            <div class="flex items-center gap-3">
              <div
                class="size-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold shrink-0"
              >
                {{ currentUser.email?.charAt(0)?.toUpperCase() }}
              </div>
              <div class="flex flex-col overflow-hidden">
                <p class="text-sm font-medium text-text-primary truncate">
                  {{ currentUser.email }}
                </p>
                <button
                  (click)="signOut()"
                  class="text-xs text-text-tertiary hover:text-primary text-left"
                >
                  Sign Out
                </button>
              </div>
            </div>
          } @else {
            <div class="flex items-center gap-3">
              <a
                routerLink="/sign-in"
                class="text-sm font-medium text-primary hover:underline"
                >Sign In</a
              >
            </div>
          }
        </div>
      </aside>

      <!-- Main Content -->
      <main class="flex-1 flex flex-col h-full overflow-hidden relative min-w-0">
        <!-- Top bar -->
        <header
          class="h-16 flex items-center justify-between px-4 md:px-8 bg-white border-b border-border-light shrink-0 z-10 gap-2"
        >
          @if (!formBuilderHeader()) {
            <!-- Hamburger (mobile/tablet only) -->
            <button
              (click)="toggleSidebar()"
              class="flex lg:hidden items-center justify-center size-10 rounded-lg text-text-secondary hover:bg-inset transition-colors shrink-0"
              aria-label="Open menu"
            >
              <span class="material-symbols-outlined">menu</span>
            </button>

            <div class="flex items-center gap-3 min-w-0 flex-1 lg:flex-none">
              <h2 class="text-base md:text-lg font-bold text-text-primary truncate">{{ title() }}</h2>
              <div class="hidden md:flex h-6 w-px bg-border-medium shrink-0"></div>
              <div class="hidden md:flex items-center shrink-0">
                <app-context-selector />
              </div>
            </div>
            <div class="flex items-center gap-2 md:gap-4 shrink-0">
              <button
                (click)="toggleTheme()"
                class="flex items-center justify-center size-10 rounded-lg text-text-secondary hover:bg-inset transition-colors"
                [attr.aria-label]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
                [attr.title]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
              >
                <span class="material-symbols-outlined">{{ isDark() ? 'light_mode' : 'dark_mode' }}</span>
              </button>
            </div>
          } @else if (formBuilderHeader(); as cfg) {
            <!-- Hamburger (mobile/tablet only) for form builder -->
            <button
              (click)="toggleSidebar()"
              class="flex lg:hidden items-center justify-center size-10 rounded-lg text-text-secondary hover:bg-inset transition-colors shrink-0"
              aria-label="Open menu"
            >
              <span class="material-symbols-outlined">menu</span>
            </button>

            <div class="flex items-center gap-2 flex-1 min-w-0">
              <button
                (click)="cfg.onBack()"
                class="text-text-tertiary hover:text-text-primary transition-colors p-1 rounded-lg hover:bg-inset shrink-0"
              >
                <span class="material-symbols-outlined">arrow_back</span>
              </button>
              <input
                type="text"
                [value]="cfg.title()"
                (input)="
                  onFormBuilderTitleChange(cfg, $any($event.target).value)
                "
                placeholder="Form title..."
                class="text-base md:text-lg font-bold text-text-primary bg-transparent border-none focus:outline-none focus:ring-0 flex-1 min-w-0 px-0 truncate"
              />
              @if (cfg.formStatus() === "active") {
                <span
                  class="hidden sm:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-success-tone-tint text-success-tone border border-success-tone-border shrink-0"
                >
                  <span class="size-1.5 rounded-full bg-success-tone"></span>
                  Active
                </span>
              } @else {
                <span
                  class="hidden sm:inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-amber-tone-tint text-amber-tone border border-amber-tone-border shrink-0"
                >
                  <span class="size-1.5 rounded-full bg-amber-tone"></span>
                  Draft
                </span>
              }
            </div>
            <div class="flex items-center gap-2 shrink-0">
              @if (cfg.hasUnsavedChanges()) {
                <span class="hidden md:inline text-xs text-text-tertiary">Unsaved changes</span>
              }
              <button
                (click)="cfg.onCancel()"
                class="hidden sm:flex items-center justify-center px-3 md:px-4 h-9 border border-border-medium rounded-lg text-sm font-medium text-text-primary hover:bg-background-light transition-colors"
              >
                Cancel
              </button>
              <button
                (click)="cfg.onSave()"
                [disabled]="cfg.saving()"
                class="flex items-center gap-2 px-3 md:px-4 h-9 bg-primary text-white rounded-lg text-sm font-bold shadow-sm hover:bg-primary-hover transition-colors disabled:opacity-50"
              >
                @if (cfg.saving()) {
                  <span
                    class="material-symbols-outlined text-[18px] animate-spin"
                    >progress_activity</span
                  >
                }
                <span class="hidden sm:inline">{{ cfg.isEditMode() ? "Save Changes" : "Create Form" }}</span>
                <span class="sm:hidden material-symbols-outlined text-[18px]">save</span>
              </button>
            </div>
          }
        </header>

        <!-- Scrollable Content -->
        <div
          class="flex-1 min-h-0 overflow-y-auto bg-background-light pt-3 pb-3 px-3"
        >
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  } @else if (isScanPage()) {
    <!--
      The public scan page, which brings its own full-height layout and can
      outgrow the viewport — a branch with thirty staff makes the picker taller
      than any phone.

      NOT the sign-in layout below, and this branch exists only because sharing
      it was a bug: that one centres its child inside the root's `h-screen
      overflow-hidden`, so a page taller than the viewport was clipped at BOTH
      ends with nothing to scroll, and a page narrower than the viewport floated
      as a column in the middle of the gradient. A card that never grows can be
      centred and clipped; this cannot.

      Scrolling lives here rather than on <body> because the root is
      `h-screen overflow-hidden`. The scan page's sticky footer sticks to this
      container, which is what it was always drawn against.
    -->
    <main class="h-full w-full overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  } @else {
    <!-- Full screen layout for sign in -->
    <main
      class="relative h-full w-full bg-gradient-to-br from-orange-50 to-white dark:from-background-dark dark:to-background-light flex items-center justify-center p-4"
    >
      <button
        (click)="toggleTheme()"
        class="absolute top-4 right-4 flex items-center justify-center size-10 rounded-lg text-text-secondary hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
        [attr.aria-label]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
        [attr.title]="isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
      >
        <span class="material-symbols-outlined">{{ isDark() ? 'light_mode' : 'dark_mode' }}</span>
      </button>
      <router-outlet></router-outlet>
    </main>
  }

  <!--
    Global toast. The shell owns where it sits — full width above the thumb on a
    phone, a card in the bottom-right from sm: — and `app-toast` owns what it
    looks like.
  -->
  @if (toast.current(); as t) {
    <div
      class="fixed bottom-4 left-3 right-3 z-[100] sm:left-auto sm:bottom-6 sm:right-6 sm:w-full sm:max-w-md"
    >
      <app-toast
        [kind]="t.type"
        [message]="t.message"
        (dismiss)="toast.dismiss()"
      />
    </div>
  }
</div>
